import { render } from "./CadastrarConstrucaoEtapas.vue?vue&type=template&id=2bb84a56"
import script from "./CadastrarConstrucaoEtapas.vue?vue&type=script&lang=js"
export * from "./CadastrarConstrucaoEtapas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__